import { captureAnalytics } from '../../actions/preload';

/**
 * Support impersonation must not attribute tutorial activity to the target
 * account. Keep the guard at the tutorial boundary so every entry point uses
 * the same analytics policy.
 */
const captureTutorialAnalytics = (impersonating, eventName, properties) => {
  if (impersonating) return;
  captureAnalytics(eventName, properties);
};

export default captureTutorialAnalytics;
